// src/services/api.js
// ==============================
// URL Config
// ==============================
import { Capacitor, CapacitorHttp } from "@capacitor/core";

// export const BASE_URL_NEW = "https://apitest.datis-elevator.ir";
// export const BASE_URL_NEW = "http://192.168.1.3:6041";
// export const BASE_URL_NEW = "http://api-backoffice-starshome.mehbang.local";
// export const BASE_URL_NEW = "http://192.168.1.3:6055";
export const BASE_URL_NEW =
  "https://testsetaregan.datis-elevator.ir/backofficeapi";
export const URLCampaign = "https://datis-elevator.ir/starsleague";
export const Version = 5;

export const iOS =
  navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

// ==============================
// Utilities
// ==============================
const persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];

export const FixNumbers = (str) => {
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) str = str.replace(persianNumbers[i], i);
  }
  return str;
};

function getOS() {
  let platform = window.navigator.platform;
  let userAgent = window.navigator.userAgent;
  if (["Macintosh", "MacIntel", "MacPPC", "Mac68K"].includes(platform))
    return "Mac";
  if (["iPhone", "iPad", "iPod"].includes(platform)) return "iOS";
  if (["Win32", "Win64", "Windows", "WinCE"].includes(platform))
    return "Windows";
  if (/Android/.test(userAgent)) return "Android";
  if (/Linux/.test(platform)) return "Linux";
  return "unknown";
}

export const Platform = getOS();

const ACCESS_KEY = "ACCESSTOKEN";
const REFRESH_KEY = "REFRESHTOKEN";

const legacyAccess = () =>
  localStorage.getItem("TOKEN") || localStorage.getItem("tokenApiNew") || "";

const legacyRefresh = () =>
  localStorage.getItem("refreshTokenApiNew") ||
  localStorage.getItem("REFRESH_TOKEN") ||
  "";

export const getAccess = () =>
  localStorage.getItem(ACCESS_KEY) || legacyAccess();

export const getRefresh = () =>
  localStorage.getItem(REFRESH_KEY) || legacyRefresh();

export const setAccess = (token) =>
  token && localStorage.setItem(ACCESS_KEY, token);

export const setRefresh = (token) =>
  token && localStorage.setItem(REFRESH_KEY, token);

export const updateTokens = (accessToken, refreshToken) => {
  if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);

  // کلیدهای قدیمی / احتمالی
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("tokenApiNew");
  localStorage.removeItem("refreshTokenApiNew");
  localStorage.removeItem("REFRESH_TOKEN");
  // window.location.href = "/Authenticate";
};

export const forceLogout = () => {
  clearTokens();

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

// ==============================
// قدیمی (URLStars) — همان قبلی‌ها با fetch
// ==============================

// ==============================
// قدیمی - Auth روی URLStars
// ==============================

// ==============================
// New HTTP Stack (BASE_URL_NEW) با رفرش خودکار
// ==============================

// ===== Single-flight refresh lock =====
let refreshPromise = null;

const refreshTokenApi = async () => {
  const refreshToken = getRefresh();
  const accessToken = getAccess();

  if (!refreshToken || !accessToken) {
    forceLogout();
    return null;
  }

  if (refreshPromise) {
    try {
      await refreshPromise;
      return getAccess() || null;
    } catch {
      forceLogout();
      return null;
    }
  }

  refreshPromise = (async () => {
    // برای refresh از وب-fetch استفاده می‌کنیم (می‌تونی اگر خواستی به CapacitorHttp هم ببری)
    const response = await fetch(`${BASE_URL_NEW}/api/Accounts/RefreshToken`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken, accessToken }),
    });

    if (!response.ok) throw new Error("refresh failed");

    const data = await response.json();

    const at =
      data?.accessToken ?? data?.result?.accessToken ?? data?.data?.accessToken;

    const rt =
      data?.refreshToken ??
      data?.result?.refreshToken ??
      data?.data?.refreshToken;

    if (!at || !rt) throw new Error("bad refresh payload");

    updateTokens(at, rt);
    return at;
  })();

  try {
    return await refreshPromise;
  } catch (e) {
    console.error("Refresh token error:", e);
    forceLogout();
    return null;
  } finally {
    refreshPromise = null;
  }
};

// ===== Response parser (وب) =====
const parseResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  if (response.status === 204) return { ok: response.ok, payload: null };

  const payload = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  return { ok: response.ok, payload };
};

// ===== Helpers =====
const buildQuery = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).reduce((acc, [k, v]) => {
      if (v !== undefined && v !== null) acc[k] = String(v);
      return acc;
    }, {})
  ).toString();

const authHeaders = (need = true, fcmToken) => {
  const h = {};
  if (need) {
    const t = getAccess();
    if (t) h.Authorization = `Bearer ${t}`;
  }
  if (fcmToken) h.fcmToken = fcmToken;
  return h;
};

// ===== Core Request (Native: CapacitorHttp | Web: fetch) با Auto-Refresh =====
const httpRequest = async (
  url,
  options = {},
  { needAuth = true, retry = true } = {}
) => {
  const method = (options.method || "GET").toUpperCase();
  const baseHeaders = { ...(options.headers || {}) };

  if (needAuth) {
    const t = getAccess();

    if (!t) {
      forceLogout();
      return {
        ok: false,
        status: 401,
        headers: {},
        payload: { message: "نیاز به ورود مجدد" },
      };
    }

    baseHeaders.Authorization = `Bearer ${t}`;
  }

  // --- Native path: CapacitorHttp (بدون CORS/Preflight)
  if (Capacitor.isNativePlatform()) {
    const req = {
      url,
      method,
      headers: baseHeaders,
    };

    // برای POST/PUT body را به data تبدیل می‌کنیم (CapacitorHttp JSON ارسال می‌کند)
    if (options.body) {
      try {
        req.data = JSON.parse(options.body);
      } catch {
        req.data = options.body;
      }
    }

    let res = await CapacitorHttp.request(req);

    // اگر 401 و اجازه‌ی retry داریم، refresh و تکرار:
    if (res.status === 401 && retry && needAuth) {
      const newAccess = await refreshTokenApi();

      if (!newAccess) {
        forceLogout();
        return {
          ok: false,
          status: 401,
          headers: res.headers,
          payload: { message: "نیاز به ورود مجدد" },
        };
      }

      const retryReq = {
        ...req,
        headers: { ...baseHeaders, Authorization: `Bearer ${newAccess}` },
      };

      res = await CapacitorHttp.request(retryReq);

      if (res.status === 401) {
        forceLogout();
      }
    }

    const ok = res.status >= 200 && res.status < 300;
    return { ok, status: res.status, headers: res.headers, payload: res.data };
  }

  // --- Web path: fetch (CORS فعال)
  let response = await fetch(url, { ...options, headers: baseHeaders });

  if (response.status === 401 && retry && needAuth) {
    const newAccess = await refreshTokenApi();

    if (!newAccess) {
      forceLogout();

      return {
        ok: false,
        status: 401,
        headers: response.headers,
        payload: { message: "نیاز به ورود مجدد" },
      };
    }

    const retryHeaders = {
      ...(options.headers || {}),
      Authorization: `Bearer ${newAccess}`,
    };

    response = await fetch(url, { ...options, headers: retryHeaders });

    if (response.status === 401) {
      forceLogout();
    }
  }

  const { ok, payload } = await parseResponse(response);
  return { ok, status: response.status, headers: response.headers, payload };
};

// ===== Public HTTP on BASE_URL_NEW (همگام با httpRequest) =====
export const GetApiNew = async (url, params = {}, need = true, fcmToken) => {
  const qs = buildQuery(params);
  const fullUrl = `${BASE_URL_NEW}${url}${qs ? `?${qs}` : ""}`;

  const { ok, status, payload } = await httpRequest(
    fullUrl,
    { method: "GET", headers: authHeaders(need, fcmToken) },
    { needAuth: need, retry: true }
  );

  if (!ok) {
    return {
      errorCode: status,
      message:
        typeof payload === "string"
          ? payload
          : payload?.message || "خطای درخواست",
    };
  }
  return typeof payload === "string"
    ? { errorCode: 0, result: payload }
    : payload;
};

export const PostApiNew = async (url, body, need = true, fcmToken) => {
  try {
    const fullUrl = `${BASE_URL_NEW}${url}`;

    const isFormData = body instanceof FormData;

    const headers = {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...authHeaders(need, fcmToken),
    };

    const options = {
      method: "POST",
      headers,
      body: isFormData ? body : JSON.stringify(body ?? {}),
    };

    const { ok, status, payload } = await httpRequest(fullUrl, options, {
      needAuth: need,
      retry: true,
    });

    if (!ok) {
      return {
        errorCode: status,
        message:
          typeof payload === "string"
            ? payload
            : payload?.message || "خطای درخواست",
      };
    }

    return typeof payload === "string"
      ? { errorCode: 0, result: payload }
      : payload;
  } catch (e) {
    console.error("PostApiNew error:", e);
    return { errorCode: -1, message: "مشکل در ارسال به سرور" };
  }
};

export const PostApiVerify = async (url, body, need = true, fcmToken) => {
  try {
    const headers = {
      "Content-Type": "application/json",
      ...(need ? { "SH-PTKN": localStorage.getItem("TOKENVERIFY") } : {}),
      ...(fcmToken ? { fcmToken } : {}),
    };
    const fullUrl = `${BASE_URL_NEW}${url}`;
    const options = {
      method: "POST",
      headers,
      body: JSON.stringify(body ?? {}),
    };

    // Verify معمولاً Bearer نمی‌خواهد، پس needAuth را false بگذار
    const { ok, status, payload } = await httpRequest(fullUrl, options, {
      needAuth: false,
      retry: false,
    });

    if (!ok) {
      return {
        errorCode: status,
        message:
          typeof payload === "string"
            ? payload
            : payload?.message || "خطای درخواست",
      };
    }
    return typeof payload === "string"
      ? { errorCode: 0, result: payload }
      : payload;
  } catch (e) {
    console.error("PostApiVerify error:", e);
    return { errorCode: -1, message: "مشکل در ارسال به سرور" };
  }
};

export const PutApiNew = async (url, body, need = true, fcmToken) => {
  try {
    const fullUrl = `${BASE_URL_NEW}${url}`;

    const isFormData = body instanceof FormData;

    const headers = {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...authHeaders(need, fcmToken),
    };

    const options = {
      method: "PUT",
      headers,
      body: isFormData ? body : JSON.stringify(body ?? {}),
    };

    const { ok, status, payload } = await httpRequest(fullUrl, options, {
      needAuth: need,
      retry: true,
    });

    if (!ok) {
      return {
        errorCode: status,
        message:
          typeof payload === "string"
            ? payload
            : payload?.message || "خطای درخواست",
      };
    }
    if (payload === null) return { errorCode: 0, result: null };
    return typeof payload === "string"
      ? { errorCode: 0, result: payload }
      : payload;
  } catch (e) {
    console.error("PutApiNew error:", e);
    return { errorCode: -1, message: "مشکل در ارسال به سرور" };
  }
};

export const DeleteApiNew = async (url, body, need = true, fcmToken) => {
  try {
    const fullUrl = `${BASE_URL_NEW}${url}`;
    const headers = {
      "Content-Type": "application/json",
      ...authHeaders(need, fcmToken),
    };
    const options = {
      method: "DELETE",
      headers,
      body: JSON.stringify(body ?? {}),
    };

    const { ok, status, payload } = await httpRequest(fullUrl, options, {
      needAuth: need,
      retry: true,
    });

    if (!ok) {
      return {
        errorCode: status,
        message:
          typeof payload === "string"
            ? payload
            : payload?.message || "خطای درخواست",
      };
    }
    if (payload === null) return { errorCode: 0, result: null };
    return typeof payload === "string"
      ? { errorCode: 0, result: payload }
      : payload;
  } catch (e) {
    console.error("DeleteApiNew error:", e);
    return { errorCode: -1, message: "مشکل در ارسال به سرور" };
  }
};

// ==============================
// New Endpoints (BASE_URL_NEW)
// ==============================

// Location
export const LocationsProvinces = (params) =>
  GetApiNew("/api/Locations/Provinces", params);
export const LocationsProvinceId = (id) =>
  GetApiNew(`/api/Locations/Provinces/${id}`);

// Account
export const AccountsAuthenticate = (body) =>
  PostApiNew("/api/Accounts/Authenticate", body, false);
export const AccountsVerify = (body) =>
  PostApiVerify("/api/Accounts/Verify", body, true);
export const AccountsRefreshToken = (body) =>
  PostApiNew("/api/Accounts/RefreshToken", body, false);
export const AccountsSignUp = (body) =>
  PostApiVerify("/api/Accounts/SignUp", body, true);
export const AccountsReferralCode = (code) =>
  PostApiVerify(`/api/Accounts/SignUp/${code}`, {}, true);

// Room
export const GetTickets = ({
  pageNumber = 1,
  pageSize = 13,
  RoomId,
  FullName,
  RoomStatusFilter,
} = {}) =>
  GetApiNew("/api/Tickets", {
    pageNumber,
    pageSize,
    RoomId,
    FullName,
    RoomStatusFilter,
  });
export const SendTickets = (body) => PostApiNew("/api/Tickets", body);
export const GetMessages = ({ roomId, beforeId, pageSize = 10 }) =>
  GetApiNew(`/api/Tickets/${roomId}/Messages`, { beforeId, pageSize });
export const SendMessages = ({ roomId, message }) =>
  PostApiNew(`/api/Tickets/${roomId}/Messages`, { message });

export const ChangeRoomStatus = ({ roomId, roomStatusInput }) =>
  PostApiNew(
    `/api/Tickets/ChangeRoomStatus/${roomId}?roomStatusInput=${roomStatusInput}`
  );

// Message
export const MessagesHistory = ({ pageNumber = 1, pageSize = 13 } = {}) =>
  GetApiNew("/api/Messages/History", { pageNumber, pageSize });

export const MessagesPublic = (params) =>
  GetApiNew("/api/Messages/Public", params);

export const MessagesPrivate = (params) =>
  PostApiNew("/api/Messages/Private", params);

// InstallationProduct
export const InstallationProduct = (params) =>
  GetApiNew("/api/InstallationProduct", params);
export const InstallationProductBySerial = (serial) =>
  GetApiNew(`/api/InstallationProduct/BySerial/${serial}`);

// User
export const GetUsers = (params) => GetApiNew("/api/Users", params);
export const UserBadges = (params) =>
  GetApiNew("/api/Users/UserBadges", params);
export const UserInfo = (params) => GetApiNew("/api/Users/UserInfo", params);
export const UpdateUserProfile = (body) =>
  PutApiNew("/api/Users/UpdateUserProfile", body);
export const AddAddress = (body) => PostApiNew("/api/Users/Address", body);
export const ListAddress = (body) => GetApiNew("/api/Users/Address", body);
export const EditeAddress = (body) => PutApiNew("/api/Users/Address", body);
export const ReferralCode = (params) =>
  GetApiNew("/api/Users/ReferralCode", params);
export const InvitedUser = (params) =>
  GetApiNew("/api/Users/invitedUser", params);

export const UsersId = (id) => GetApiNew(`/api/Users/${id}`);

export const UserStatistics = (params) =>
  GetApiNew("/api/Users/UserStatistics", params);

export const ScannerRequirement = async (body) => {
  try {
    const response = await fetch(
      `${BASE_URL_NEW}/api/Users/ScannerRequirement`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...(getAccess() ? { Authorization: `Bearer ${getAccess()}` } : {}),
        },
        body: JSON.stringify(body ?? {}),
      }
    );

    if (response.status === 401) {
      const newAccess = await refreshTokenApi();

      if (!newAccess) {
        forceLogout();
        return {
          errorCode: 401,
          message: "نیاز به ورود مجدد",
        };
      }

      const retryResponse = await fetch(
        `${BASE_URL_NEW}/api/Users/ScannerRequirement`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${newAccess}`,
          },
          body: JSON.stringify(body ?? {}),
        }
      );

      if (retryResponse.status === 401) {
        forceLogout();
        return {
          errorCode: 401,
          message: "نیاز به ورود مجدد",
        };
      }

      const retryContentType = retryResponse.headers.get("content-type") || "";

      const retryPayload = retryContentType.includes("application/json")
        ? await retryResponse.json()
        : await retryResponse.text();

      if (!retryResponse.ok) {
        return {
          errorCode: retryResponse.status,
          message:
            typeof retryPayload === "string"
              ? retryPayload
              : retryPayload?.message || "خطای درخواست",
        };
      }

      return typeof retryPayload === "string"
        ? { errorCode: 0, result: retryPayload }
        : retryPayload;
    }

    const contentType = response.headers.get("content-type") || "";

    const payload = contentType.includes("application/json")
      ? await response.json()
      : await response.text();

    if (!response.ok) {
      return {
        errorCode: response.status,
        message:
          typeof payload === "string"
            ? payload
            : payload?.message || "خطای درخواست",
      };
    }

    return typeof payload === "string"
      ? { errorCode: 0, result: payload }
      : payload;
  } catch (e) {
    console.error("ScannerRequirement error:", e);
    return { errorCode: -1, message: "مشکل در ارسال به سرور" };
  }
};

// Installation
export const AddNewInstallations = (body) =>
  PostApiNew("/api/Installations", body);
export const GetInstallationsPaged = ({
  pageNumber = 1,
  pageSize = 13,
  UserName,
  Serial,
  Code,
  InstallatopnProductName,
  FromDate,
  ToDate,
  OrderBy,
  IsAscending,
} = {}) =>
  GetApiNew("/api/Installations", {
    pageNumber,
    pageSize,
    UserName,
    Serial,
    Code,
    InstallatopnProductName,
    FromDate,
    ToDate,
    OrderBy,
    IsAscending,
  });
export const UserInstallation = ({ pageNumber = 1, pageSize = 13 } = {}) =>
  GetApiNew("/api/Installations/UserInstallation", { pageNumber, pageSize });
export const ChargeUserPhone = (body) =>
  PostApiNew(`/api/Installations/ChargeUserPhone`, body);
export const InstallationsAccelerometerData = (installationId) =>
  GetApiNew(`/api/Installations/AccelerometerData/${installationId}`);
export const AccelerometerInfo = (body) =>
  PostApiNew("/api/Installations/AccelerometerInfo", body);
export const InstallationsUserInstallation = ({
  userId,
  pageNumber,
  pageSize,
}) =>
  GetApiNew(
    `/api/Installations/UserInstallation/${userId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
export const UserCharge = ({ userId, pageNumber, pageSize }) =>
  GetApiNew(
    `/api/Installations/UserCharge/${userId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );

export const InstallationsStatistics = (params) =>
  GetApiNew("/api/Installations/Statistics", params);

export const InstallationsReport = ({ fromDate, toDate } = {}) =>
  GetApiNew("/api/Installations/Report", { fromDate, toDate });

// UserTransaction

export const SpinWheelEligibility = (params) =>
  GetApiNew("/api/Transaction/SpinWheel/Eligibility", params);
export const SpinWheel = (params) =>
  GetApiNew("/api/Transaction/SpinWheel", params);
export const UserCoins = (params) =>
  GetApiNew("/api/Transaction/UserCoins", params);
export const Transaction = ({ userId, pageNumber, pageSize }) =>
  GetApiNew(
    `/api/Transaction/${userId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );

export const UserWallet = (body) =>
  PostApiNew("/api/Transaction/UserWallet", body);
// Common
export const CallWithMe = (params) =>
  PostApiNew("/api/Common/CallWithMe", params);

export const ChangeMapAvailability = ({ hasInternet }) =>
  PostApiNew(`/api/Common/MapAvailability?hasInternet=${hasInternet}`);
export const GetMapAvailability = (params) =>
  GetApiNew("/api/Common/MapAvailability", params);

// Target
export const StateData = (params) =>
  GetApiNew("/api/Targets/StateData", params);
export const TargetsRequest = (params) =>
  GetApiNew("/api/Targets/Request", params);
export const TargetsSelect = (params) =>
  PostApiNew("/api/Targets/Select", params);

// Product

export const DeleteProducts = (productId) =>
  DeleteApiNew(`/api/Products?productId=${productId}`);

export const AddProducts = ({
  Description,
  IsActive,
  Name,
  Price,
  Attachments,
  CurrencyId,
  CategoryId,
  CampaignId,
}) => {
  const formData = new FormData();
  formData.append("Description", Description ?? "");
  formData.append("IsActive", String(IsActive ?? true));
  formData.append("Name", Name ?? "");
  formData.append("Price", String(Price ?? ""));
  formData.append("CurrencyId", CurrencyId);
  formData.append("CategoryId", CategoryId);
  if (CampaignId !== null && CampaignId !== undefined) {
    formData.append("CampaignId", CampaignId);
  }
  if (Attachments) {
    formData.append(`Attachments[${0}].order`, 1);
    formData.append(`Attachments[${0}].file`, Attachments.file);
  }

  return PostApiNew("/api/Products", formData);
};

export const ListProducts = (params) =>
  GetApiNew("/api/Products/AllProducts", params);

export const EditeProducts = ({
  Description,
  IsActive,
  Name,
  Picture,
  Price,
  Id,
  productGuids,
  Attachments,
}) => {
  const formData = new FormData();

  formData.append("Description", Description);
  formData.append("IsActive", IsActive);
  formData.append("Name", Name);
  formData.append("Price", Price);
  formData.append("Id", Id);

  if (Attachments) {
    if (Attachments.file) {
      formData.append(`Attachments[${0}].order`, 1);
      formData.append(`Attachments[${0}].file`, Attachments.file);
    } else {
      formData.append(`Attachments[${0}].id`, Attachments.id);
    }
  }

  return PutApiNew("/api/Products", formData);
};

export const CashProducts = (params) =>
  GetApiNew("/api/Products/CashProducts", params);

//ProductCode

export const AddProductCode = (params) =>
  PostApiNew("/api/ProductCode", params);

export const ProductCode = (params) => GetApiNew("/api/ProductCode", params);

export const GenerateProductCode = (productCodeId, count) =>
  PostApiNew(`/api/ProductCode/${productCodeId}/generate`, {
    count,
  });

export const ListCodesProduct = (params) =>
  GetApiNew("/api/ProductCode/codes", params);

// Cart
export const AddProductId = (productId) =>
  PostApiNew(`/api/Cart/Add/${productId}`);

export const RemoveProductId = (productId) =>
  PostApiNew(`/api/Cart/Decrement/${productId}`);

export const Cart = (params) => GetApiNew("/api/Cart", params);

export const CartCheckout = (params) =>
  PostApiNew("/api/Cart/Checkout", params);

export const CartOrders = (params) => GetApiNew("/api/Cart/Orders", params);

export const CartApprove = (params) => PostApiNew(`/api/Cart/Approve`, params);

export const CartReject = (params) => PostApiNew(`/api/Cart/Reject`, params);

export const DeleteCart = ({ productId }) =>
  DeleteApiNew(`/api/Cart/Delete/${productId}`);

//Campaign
export const GetCampaign = (params) => GetApiNew("/api/Campaign", params);
export const CampaignCampaignId = ({ campaignId }) =>
  GetApiNew(`/api/Campaign/${campaignId}`);
